import { render, staticRenderFns } from "./alta.vue?vue&type=template&id=22d6343e"
import script from "./alta.vue?vue&type=script&lang=js"
export * from "./alta.vue?vue&type=script&lang=js"
import style0 from "./alta.vue?vue&type=style&index=0&id=22d6343e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports